module.exports = __webpack_public_path__ + "static/img/6.bdf1d1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/6.png
// module id = cSFV
// module chunks = 35